<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title"><strong>OPÇÕES DE TABELA</strong></h3>
  </div>

  <form [formGroup]="formulario" class="forms" (ngSubmit)="save()">
    <div class="modal-body">
      <div class="form-group d-block">
        <label for="tabela" class="label-full-width">Opções disponíveis</label>
        <select
          class="form-control"
          appShowErrorMessages
          requiredMessage="O campo tabela é obrigatório"
          formControlName="tabela"
          name="tabela"
        >
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let tabela of tabelas" value="{{ tabela.id }}">
            {{ tabela.descricao }}
          </option>
        </select>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="bt-back btn btn-border-orange"
        (click)="close()"
      >
        Fechar
      </button>

      <button
        type="submit"
        class="bt-go btn btn-full-orange"
        [disabled]="!formulario.valid"
      >
        Salvar
      </button>
    </div>
  </form>
</div>
